import { render, staticRenderFns } from "./Characteristics.vue?vue&type=template&id=ac6bfc80&"
import script from "./Characteristics.vue?vue&type=script&lang=js&"
export * from "./Characteristics.vue?vue&type=script&lang=js&"
import style0 from "./Characteristics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports